module.exports = __webpack_public_path__ + "img/red-circle-table-10.59430f15.png";